import { TEMA_NOT_FOUND_ROUTE, TEMA_ROUTES } from "./temaRoutes";

export function normalizeTemaHash(hash = "") {
  const trimmed = hash.trim();
  if (!trimmed || trimmed === "#") {
    return "#";
  }

  return trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
}

export function resolveTemaRoute(hash = "") {
  const normalized = normalizeTemaHash(hash);

  const matchedRoute = TEMA_ROUTES.find(
    (route) =>
      route.path === normalized ||
      route.aliases?.some((alias) => alias === normalized),
  );

  return matchedRoute ?? TEMA_NOT_FOUND_ROUTE;
}

export function getTemaRouteById(routeId) {
  return TEMA_ROUTES.find((route) => route.id === routeId) ?? TEMA_NOT_FOUND_ROUTE;
}

export function listWorkspaceRoutes() {
  return TEMA_ROUTES.filter((route) => route.workspace);
}
